import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, } from 'react';
import theme from '../../styles/theme';
import { SelectCustomContext } from './SelectCustomContext';
const defaultProps = {
    isDisabled: false,
};
const SelectCustomOption = ({ children, isDisabled = defaultProps.isDisabled, text, value, }) => (_jsx(SelectCustomContext.Consumer, { children: ({ onChange = () => { }, selectedValue, }) => (_jsx("li", Object.assign({ "aria-disabled": isDisabled, "aria-selected": value === selectedValue, css: css `
              ${theme.typeStyles.bodyMediumStyles}
              cursor: pointer;
              padding-bottom: ${theme.spacing.x3};
              padding-left: ${theme.spacing.x3};
              padding-right: ${theme.spacing.x3};
              padding-top: ${theme.spacing.x3};

              &:hover {
                background-color: ${theme.colors.gray200};
              }

              ${isDisabled && css `
                color: ${theme.colors.gray500};
                cursor: default;
              `}
            `, onClick: isDisabled
            ? () => { }
            : () => {
                onChange({
                    text,
                    value,
                });
            }, role: "option", value: value }, { children: children || text }))) }));
const MemoizedSelectCustomOption = memo(SelectCustomOption);
MemoizedSelectCustomOption.displayName = 'SelectCustomOption';
export { MemoizedSelectCustomOption as SelectCustomOption };
// MC-1068 Temporary hack for Storybook.
export default MemoizedSelectCustomOption;
